import { h } from '@qiov/logicflow-core'
import BaseNode from './BaseNode'

class StartNode extends BaseNode.view {
  getIcon() {
    const { model, graphModel } = this.props
    const {
      width,
      height
    } = model
    return h('image', {
      width: 20,
      height: 36,
      x: -width / 2 + 8,
      y: -height / 2,
      className: 'node-red-start',
      href: '/images/start.svg',
      onClick: () => {
        graphModel.eventCenter.emit('node-red:start')
      }
    })
  }
}

class StartNodeModel extends BaseNode.model {
  /**
   * 重写定义锚点
   */
  getDefaultAnchor() {
    const { x, y, id, width, height } = this
    const anchors = [
      {
        x: x,
        y: y + height / 2,
        id: `${id}_bottom`,
        type: 'bottom'
      }
    ]
    return anchors
  }
  initNodeData(data) {
    super.initNodeData(data)
    this.height = 36
    this.defaultFill = 'rgb(166, 187, 207)'
  }
  getConnectedTargetRules() {
    const rules = super.getConnectedTargetRules()
    const notAsTarget = {
      message: '起始节点不能作为边的终点',
      validate: () => false,
    }
    rules.push(notAsTarget)
    return rules
  }
}

export default {
  type: 'start-node',
  model: StartNodeModel,
  view: StartNode
}
